import { Component, OnInit, Input, SimpleChanges, OnDestroy, AfterViewInit, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormService } from '../../services/form.service';
import { AppService } from 'src/app/app.service';
import { ModalService } from 'src/app/common/modal/modal.service';
import  {Constant}  from '../../../constants/constants';
import { APP_Constants } from 'src/app/app.constant';
import { Modal } from 'src/app/common/modal/modal';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';

@Component({
    selector: 'app-form-field-button-toggle',
    templateUrl: './form-field-button-toggle.component.html',
    styleUrls: ['./form-field-button-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldButtonToggleComponent implements OnInit, OnDestroy, AfterViewInit {

  constructor(private formService:FormService, private appService: AppService,  private modalService : ModalService) { }

  @Input() configData;
  @Input() frmGroup;
  @ViewChild('dynamicWidth',{static: true, read: ElementRef}) dynamicWidth: ElementRef;
  toggleOptions;
  sub;
  selectedBtn:any=[];
  dynamicWidthValue : any;
  selfServiceConfig: boolean = false;
  editField: boolean;
  isLoading: boolean;
  templateData: any;
  rderFormSubmitted: any;
  orderForm: any;
  orderFormSubmitted: any;
  ngOnInit() {
    console.log(this.configData);
    console.log(this.frmGroup);
    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }

    this.toggleOptions = this.configData.options;
    console.log(this.toggleOptions);
    this.sub = this.frmGroup.get(this.configData.name).valueChanges
      .subscribe(selectedValue => {
        this.onToggleGroupChange({ value: selectedValue }, false);
      });
  }

  ngAfterViewInit(){
    if(this.frmGroup.get(this.configData.name).value){
      setTimeout(()=>{
        this.onToggleGroupChange({ value: this.frmGroup.get(this.configData.name).value }, true);
      }, 10)
    }
    this.dynamicWidthValue = this.dynamicWidth.nativeElement.offsetWidth;
  }
  /**
   * Change : Freight details to be mandatory only when LTL is selected or nothing is selected
   * Step1: Filtering configData.relatedCoumns based on value variable, which is filteredRelatedCols.
   * Step2: Sorting filteredRelatedCols to find high priority one.
   * step3: Apply validation based on high priority one
   * ex : LTL is level-1, TL,INTERMODAL are level-0,
   * case 1: if value has LTL, Then LTL will be high priority one.
   * If value == [], Then LTL will be high priority one. its validation will be applied.
   * if value == ["LT"] or ["INTERMODAL"] or ["LT","INTERMODAL"] then its validation will be applied
  */
  public onToggleGroupChange({ value }, keepValue): void {
    value = value || [];
    let relatedCol: any = [];
    const relatedColumns = this.configData.relatedColumns || this.configData.relatedCoumns;
    if(value && value.length){
      let filteredRelatedCols: any = [];
      relatedColumns.forEach(col => {
        value.forEach(val => {
          if (col.key == val) {
            filteredRelatedCols.push(col);
          }
        });
      });
      filteredRelatedCols.sort(this.sortRelatedCols);
      relatedCol = filteredRelatedCols[0];
        } else{
      relatedCol = relatedColumns.sort(this.sortRelatedCols)[0];
    }
    let multipleValue;
    if(relatedCol['multipleValue']){
      multipleValue = relatedCol['multipleValue'];
    } else {
      multipleValue = relatedCol.values;
    }
    multipleValue.forEach(ctrl => {
      let req = ctrl.required ? [Validators.required] : null;
      let controls = this.formService.getFormControl(this.frmGroup, [ctrl.name || ctrl.controlName]);
      this.appService._components[ctrl.name].configData['required'] = ctrl.required;
      // controls && controls[0] && controls[0].control.setValidators(req);
      if (ctrl.reset && !keepValue) {
        controls[0].control.reset();
        }
      controls && controls[0] && controls[0].control.updateValueAndValidity();
      controls && controls[0] && controls[0].control.markAsUntouched();
    }, this);
  }

  sortRelatedCols(a,b){
    let comparison = 0;
    if (a.level < b.level) {
      comparison = 1;
    }
    else if (a.level > b.level) {
      comparison = -1;
    }
    return comparison;
  }


  ngOnDestroy(){
    this.sub.unsubscribe();
  }

  normalView() {
    throw new Error('Method not implemented.');
  }

}